import { styleVariants } from '@vanilla-extract/css';
import { DividerDirection, DividerVariant } from './Divider.types';
import { nToPx, themeVars } from '@tundr/theme';

export const dividerDirectionClass = styleVariants({
  [DividerDirection.HORIZONTAL]: {
    width: '100%',
    height: 1,
    margin: nToPx(themeVars.space.x4, 0),
  },
  [DividerDirection.VERTICAL]: {
    width: 1,
    height: '100%',
    margin: nToPx(0, themeVars.space.x4),
  },
});

export const dividerColorClass = styleVariants({
  [DividerVariant.DARK]: {
    backgroundColor: themeVars.colors.neutrals.black100,
  },
  [DividerVariant.LIGHT]: {
    backgroundColor: themeVars.colors.neutrals.grey40,
  },
  [DividerVariant.PRIMARY]: {
    backgroundColor: themeVars.colors.brand.primary.x100,
  },
});
